import { __assign, __read } from "tslib";
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { createRocket } from "../_util/create-rocket";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
import { useConfig } from "../_util/config-context";
import { isChildOfType } from "../_util/is-child-of-type";
import { ListItem } from "./ListItem";
import { ListSubMenu } from "./ListSubMenu";
import { ListItemContent } from "./ListItemContent";
import { ListItemDecorator } from "./ListItemDecorator";
import { ListItemButton } from "./ListItemButton";
import { ListDivider } from "./ListDivider";
// import { ListGroupTitle } from "./ListGroupTitle";
import { ListSearchBox } from "./ListSearchBox";
var ListContext = React.createContext({
    type: "none",
});
export var useListContext = function () { return React.useContext(ListContext); };
export var List = forwardRefWithStatics(function List(_a, ref) {
    var _b;
    var className = _a.className, style = _a.style, children = _a.children, type = _a.type, split = _a.split, _c = _a.onScrollBottom, onScrollBottom = _c === void 0 ? function () { return null; } : _c;
    var classPrefix = useConfig().classPrefix;
    var _d = __read(useState(false), 2), hasSubMenu = _d[0], setHasSubMenu = _d[1];
    useEffect(function () {
        React.Children.forEach(children, function (child) {
            if (isChildOfType(child, ListSubMenu)) {
                setHasSubMenu(true);
            }
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    function handleBodyScroll(event) {
        var list = event.target;
        var scrollHeight = list.scrollHeight, scrollTop = list.scrollTop, clientHeight = list.clientHeight;
        if (scrollHeight <= Math.ceil(clientHeight + scrollTop + 1)) {
            onScrollBottom(event);
        }
    }
    var digits = String(React.Children.count(children)).length;
    var listClassName = classNames((_b = {},
        _b[classPrefix + "-list"] = true,
        _b[classPrefix + "-list--bullet"] = type === "bullet",
        _b[classPrefix + "-list--number"] = type === "number",
        _b[classPrefix + "-list--plain"] = type === "plain" || type === "plain-group",
        _b[classPrefix + "-list--option"] = type === "option" || type === "option-group",
        _b[classPrefix + "-list--group"] = type === "option-group" || type === "plain-group",
        _b[classPrefix + "-list--divider"] = split === "divide",
        _b[classPrefix + "-list--striped"] = split === "stripe",
        _b["is-2digits"] = type === "number" && digits === 2,
        _b["is-3digits"] = type === "number" && digits === 3,
        _b["is-4digits"] = type === "number" && digits > 3,
        _b[className] = className,
        _b));
    var Parent = type === "number" ? "ol" : "ul";
    return (React.createElement(Parent, { ref: ref, className: listClassName, style: __assign({ 
            // 多级菜单展开
            maxHeight: hasSubMenu ? "none" : undefined }, (style || {})), onScroll: handleBodyScroll },
        React.createElement(ListContext.Provider, { value: {
                type: type,
            } }, children)));
}, {
    GroupLabel: createRocket("GroupLabel", "li.@{prefix}-list__label"),
    Divider: createRocket("Divider", "li.@{prefix}-list__separate"),
    StatusTip: createRocket("TipItem", "li.@{prefix}-list__status"),
    SubMenu: ListSubMenu,
    Item: ListItem,
    ItemButton: ListItemButton,
    ItemContent: ListItemContent,
    ItemDecorator: ListItemDecorator,
    ListDivider: ListDivider,
    // GroupTitle: ListGroupTitle,
    SearchBox: ListSearchBox,
});
List.displayName = "List";
//# sourceMappingURL=List.js.map